module.exports = __webpack_public_path__ + "img/btn/button-secondary@2x.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary@2x.png
// module id = 63
// module chunks = 3